import styled from 'styled-components';
export default styled.div.withConfig({
  displayName: "StyledProperty",
  componentId: "sc-7jqhgb-0"
})(["line-height:28px;margin-bottom:4px;"]);